var map = {
	"./de": 86034,
	"./en": 55630,
	"./es": 39469,
	"./fr": 19338,
	"./it": 42661,
	"./kde": 64336,
	"./nl": 14675,
	"./pl": 41922,
	"./pt": 85900,
	"./ses": 34795,
	"./sr": 74454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5549;